import { render, staticRenderFns } from "./DeleteCollectionVariableIconDialog.vue?vue&type=template&id=58088c7c&scoped=true"
import script from "./DeleteCollectionVariableIconDialog.vue?vue&type=script&lang=js"
export * from "./DeleteCollectionVariableIconDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58088c7c",
  null
  
)

export default component.exports